import {
    createStructuresField,
    createStructuresFieldValidation,
} from 'constants/FormField/createStructuresField'
import useFromFieldWithAccount from 'logic/useFromFieldWithAccount'

const useStructures = () => {
    const {fieldsCreate, fieldsEdit, isLoading, validationSchema} = useFromFieldWithAccount({
        fieldsCreate: createStructuresField,
        fieldsEdit: createStructuresField,
        validationSchema: createStructuresFieldValidation,
    })

    return {
        fieldsCreate,
        fieldsEdit,
        isLoading,
        validationSchema,
    }
}

export default useStructures
